import React, { Component } from 'react';
import { CalendarioContentPanel } from './CalendarioContentPanel';
import FetchService from '../../services/FetchService.js';

export class CalendarioForm extends Component {
    constructor(props) {
        super(props); 
    }
    componentDidMount() { 
    }  
    render() {
        return (
            <div> 
                <div>
                    <CalendarioContentPanel />
                </div> 
            </div>
        );
    }
}
